import React, { useEffect, useState } from 'react'
import { CustomDataGrid } from '../../../../components/common/CustomDataGrid';
import { Divider, IconButton, Menu, MenuItem, Stack, Tooltip } from '@mui/material';
import { useTheme } from '../../../../components/hooks/useTheme';
import { GridColDef } from '@mui/x-data-grid';
import baseURL from '../../../../configs/api';
import { Build } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import useTenant from '../../../../components/hooks/useTenant';


type MaintenanceHistoryListProps = {
    paginationModel: any;
    setPaginationModel: (value: any) => void;
    idNumber: any;
}

const MaintenanceHistoryList = ({
    paginationModel,
    setPaginationModel,
    idNumber,
}: MaintenanceHistoryListProps) => {
    const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
    const { themeStyles } = useTheme();
    const { handleTenantError }: any = useTenant();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [searchTableData, setSearchTableData] = useState<any[]>([]);
    const [totalLength, setTotalLength] = useState<number>(0);
    const [columnFilterAnchorEl, setColumnFilterAnchorEl] = useState<null | HTMLElement>(null);
    const columnFilterOpen = Boolean(columnFilterAnchorEl);
    const initialColumns: GridColDef[] = [
        {
            field: "id",
            headerName: "#",
            flex: 1,
            editable: false,
            sortable: false,
            align: "left",
        },
        {
            field: "odometer",
            headerName: "Odometer",
            align: "left",
            flex: 1,
            editable: false,
            sortable: false,
        },
        {
            field: "maintenanceDate",
            headerName: "Maintenance Date",
            align: "left",
            editable: false,
            sortable: false,
            flex: 1,
        },
        {
            field: "vehicleRepairOrderId",
            headerName: "Action",
            width: 80,
            align: "center",
            editable: false,
            sortable: false,
            renderCell: (params) => {

                return (

                    <Tooltip title="View Repair Order">
                        <IconButton
                            onClick={() =>
                                navigate("/fleet/repairorders/editrepairorder", {
                                    state: params.value,
                                })
                            }
                        >
                            <Build
                                sx={{
                                    fontSize: "14px",
                                    color: "blue",
                                    transform: "rotate(90deg)",
                                }}
                            />
                        </IconButton>
                    </Tooltip>
                );
            },
        },
    ];
    const [columns, setColumns] = useState<GridColDef[]>(initialColumns);
    const [selectedColumns, setSelectedColumns] = useState(initialColumns?.map(col => col?.headerName));


    const handleColumnFilterClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setColumnFilterAnchorEl(event.currentTarget);
    };
    const handleColumnFilterClose = () => {
        setColumnFilterAnchorEl(null);
    };

    const toggleColumn = (headerName: string) => {
        setSelectedColumns(prev =>
            prev.includes(headerName) ? prev.filter(col => col !== headerName) : [...prev, headerName]
        );
    };

    useEffect(() => {
        const filterCol = initialColumns?.filter(col => selectedColumns?.includes(col?.headerName));
        setColumns(filterCol);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedColumns])

    const toggleAll = () => {
        if (selectedColumns?.length === initialColumns?.length) {
            setSelectedColumns([]);
        } else {
            setSelectedColumns(initialColumns?.map(col => col?.headerName));
        }
    };

    useEffect(() => {
        apiCall(paginationModel);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationModel])


    const apiCall = (newPaginationModel: any) => {
        let filterData: any[] = [];
        setLoading(true);

        fetch(`${baseURL}vehicleMaintenanceHistories/GetVehicleMaintenanceHistoryReportPagingByVehicleId/${idNumber?.state},${newPaginationModel.page},${newPaginationModel.pageSize}`, {
            headers: {
                'X-Tenant-ID': tenantId,
            }
        })
            .then((res) => res.json())
            .then((data) => {
                filterData = data.vehicleMaintenanceHistories.map((item: any) => {
                    return {
                        ...item,
                        maintenanceDate: new Intl.DateTimeFormat('en-US').format(new Date(item.maintenanceDate))
                    };
                });

                setSearchTableData(filterData);
                setTotalLength(data.count);
                setLoading(false);
                handleTenantError(null);
            })
            .catch((error) => {            
                handleTenantError(error);
                setSearchTableData([]);
                setLoading(false);
            });
    }

    return (
        <>
            <div className="w-full mt-2">
                <div className={`w-full border ${themeStyles.main.borderColor} rounded-[16px]`}>
                    <div className={`flex justify-between items-center p-4 border-b ${themeStyles.main.borderColor}`}>
                        <div className="flex items-center gap-1.5">

                            <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Maintenance History</h2>

                            <div >
                                <button
                                    className={`flex items-center justify-between py-[5px] px-[12px] gap-2.5 rounded-lg border border-solid ${themeStyles.topBar.tailwindBorderColor}`}
                                    aria-controls={columnFilterOpen ? 'basic-menu' : undefined}
                                    aria-haspopup="true"
                                    aria-expanded={columnFilterOpen ? 'true' : undefined}
                                    onClick={handleColumnFilterClick}
                                >
                                    <Stack
                                        direction="row"
                                        spacing={1}
                                        alignItems={"center"}
                                        justifyContent={"center"}
                                    >
                                        <span className={`${themeStyles.topBar.tailwindTextColor} text-[14px] font-medium`}>Columns</span>
                                        <span className={`material-symbols-outlined text-[18px] font-light ${themeStyles.main.textHeadingColor}`}>
                                            filter_alt
                                        </span>
                                    </Stack>
                                </button>

                                <Menu
                                    id="basic-menu"
                                    anchorEl={columnFilterAnchorEl}
                                    open={columnFilterOpen}
                                    onClose={handleColumnFilterClose}
                                    slotProps={{
                                        paper: {
                                            sx: {
                                                width: 170,
                                                maxHeight: 300,
                                                backgroundColor: themeStyles.topBar.bg
                                            }
                                        }
                                    }}
                                >
                                    <div className="flex items-center gap-2 px-[16px] py-[6px] w-full">
                                        <input
                                            type="checkbox"
                                            className="form-checkbox cursor-pointer"
                                            checked={selectedColumns?.length === initialColumns?.length ? true : false}
                                            onClick={toggleAll}
                                        />
                                        <span className={`${themeStyles.topBar.tailwindTextColor} font-medium text-[12px]`}>Select All</span>
                                    </div>

                                    <Divider className="w-full" />

                                    {
                                        initialColumns?.map((column, index) => ([
                                            <MenuItem
                                                key={`${index}-Item`}
                                                sx={{
                                                    fontSize: "12px",
                                                    marginBlock: "0px",
                                                    "&: hover": {
                                                        cursor: "default"
                                                    }
                                                }}
                                            >
                                                <div className="flex items-center gap-2">
                                                    <input
                                                        type="checkbox"
                                                        className="form-checkbox cursor-pointer"
                                                        checked={selectedColumns.includes(column?.headerName)}
                                                        onChange={() => toggleColumn(column?.headerName || "")}
                                                    />
                                                    <span className={`${themeStyles.topBar.tailwindTextColor} font-medium`}>{column?.headerName}</span>
                                                </div>

                                            </MenuItem>,
                                            <Divider key={`${index}-Divider`} className="w-full" />
                                        ]
                                        ))
                                    }
                                </Menu>
                            </div>
                        </div>
                    </div>

                    <CustomDataGrid
                        filteredRows={searchTableData}
                        columns={columns?.map(col => ({
                            ...col,
                            headerClassName: themeStyles.table.headerBg,
                        }))}
                        loading={loading}
                        totalLength={totalLength}
                        paginationModel={paginationModel}
                        setPaginationModel={setPaginationModel}
                    />
                </div>
            </div>
        </>

    )
}

export default MaintenanceHistoryList